module.exports = __webpack_public_path__ + "img/notas-musicais.8e8a5c42.png";